const BaseRandomizer = require('./base');
const { shuffle } = require('../math/seed-rng');
const { validateClusters } = require('../math/validation');

class ClusteredRandomization extends BaseRandomizer {
  constructor() {
    super('clustered', 'Clustered Randomization');
  }

  validateParams(params) {
    params.clusters = validateClusters(params.clusterSizes, params.n);
  }

  selectResultParameters(params) {
    return {
      ...super.selectResultParameters(params),
      clusters: params.clusters,
      clusterSizes: params.clusterSizes
    };
  }

  randomize(rng, params) {
    const clusterArmPlan = [];

    params.clusters.forEach((cluster, index) => {
      clusterArmPlan.push({
        ...cluster,
        originalIndex: index
      });
    });

    const balancedArms = [];
    for (let i = 0; i < clusterArmPlan.length; i += 1) {
      balancedArms.push(i % params.arms);
    }

    const shuffledArms = shuffle(balancedArms, rng);
    const sequence = [];
    let patientIndex = 0;

    clusterArmPlan.forEach((cluster, clusterIndex) => {
      const armIndex = shuffledArms[clusterIndex];

      for (let i = 0; i < cluster.size; i += 1) {
        sequence.push(this.buildAssignment(patientIndex, armIndex, {
          cluster: cluster.id,
          stratum: cluster.id
        }));
        patientIndex += 1;
      }
    });

    return sequence;
  }

  getExplanation() {
    return `
      <h3>Clustered Randomization</h3>
      <p>Clusters are assigned as intact units, so all participants in the same cluster remain in the same arm.</p>
      <pre>For each cluster:
  assign one arm using seeded balanced allocation
  apply that arm to every participant in the cluster</pre>
      <p>This V1 format protects cluster boundaries and documents balance by cluster.</p>
    `;
  }
}

module.exports = ClusteredRandomization;
